import request from '@/request'

const state = {
}
const mutations = {
}
const actions = {
    // post请求
    async http_post({ state }, { url, payload }) {
        state; // 解决定义未使用报错
        let res = await request.post(url, payload)
        return res;
    },
}

export default {
    state,
    mutations,
    actions
}
